module.exports = __webpack_public_path__ + "static/img/csm_bg.123703f2.png";